/**
 * SYSTEM SETTINGS MODULE — page shell.
 * Sidebar of setup sections + content. Reuses the global settings-* layout so it
 * reads as a sibling of Account settings. Workspace owner/admin only (gated by
 * the route's RequireWorkspaceAdmin).
 */

import { useState } from "react";
import ProductSkusSection from "../components/ProductSkusSection.jsx";
import StatesSection from "../components/StatesSection.jsx";
import SyncSettingsSection from "../components/SyncSettingsSection.jsx";
import ShippingCarriersSection from "../components/ShippingCarriersSection.jsx";
import PointOfSaleSetupSection from "../components/PointOfSaleSetupSection.jsx";
import ProductSampleOrdersSetupSection from "../components/ProductSampleOrdersSetupSection.jsx";
import IncentivesSection from "../components/IncentivesSection.jsx";

const SECTIONS = [
  { id: "products", label: "Product SKUs" },
  { id: "states", label: "States & Distributors" },
  { id: "pos-setup", label: "Point of Sale Setup" },
  { id: "sample-setup", label: "Product Sample Orders Setup" },
  { id: "incentives", label: "Incentives" },
  { id: "sync", label: "Sync Settings" },
  { id: "shipping", label: "Shipping Carriers" },
];

function initialTab() {
  const t = new URLSearchParams(window.location.search).get("tab");
  return SECTIONS.some((s) => s.id === t) ? t : "products";
}

export default function SystemSettings() {
  const [tab, setTab] = useState(initialTab);
  return (
    <div className="settings-layout">
      <aside className="settings-nav">
        <h1>System Settings</h1>
        <nav>
          {SECTIONS.map((s) => (
            <button
              key={s.id}
              className={`settings-navitem ${tab === s.id ? "active" : ""}`}
              onClick={() => setTab(s.id)}
            >
              {s.label}
            </button>
          ))}
        </nav>
      </aside>
      <div className="settings-content">
        {tab === "products" && <ProductSkusSection />}
        {tab === "states" && <StatesSection />}
        {tab === "pos-setup" && <PointOfSaleSetupSection />}
        {tab === "sample-setup" && <ProductSampleOrdersSetupSection />}
        {tab === "incentives" && <IncentivesSection />}
        {tab === "sync" && <SyncSettingsSection />}
        {tab === "shipping" && <ShippingCarriersSection />}
      </div>
    </div>
  );
}
